import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import useStores from '@stores/useStores';

export const with404Redirect =
  <T extends object>(
    Component: React.ComponentType<T>,
    { exists, redirectPath }: { exists: (id: string) => boolean; redirectPath: string },
  ) =>
  (props: T) => {
    const { messagesStore } = useStores();
    const { id } = useParams<{ id?: string }>() ?? {};

    if (id && !exists(id)) {
      messagesStore.showInfoMessage('Resource not found');
      return <Navigate to={redirectPath} replace />;
    }

    return <Component {...props} />;
  };
